import { render, staticRenderFns } from "./OtherVendorsModal.vue?vue&type=template&id=c87791de&scoped=true&"
import script from "./OtherVendorsModal.vue?vue&type=script&lang=js&"
export * from "./OtherVendorsModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherVendorsModal.vue?vue&type=style&index=0&id=c87791de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87791de",
  null
  
)

export default component.exports